<apto-card
    *ngIf="(company && company._id) || (contact && contact._id)"
    class="landlord-card">
    <apto-card-header noBottomPadding>Landlord</apto-card-header>
    <apto-card-content noPadding>
        <apto-list>
            <apto-list-item
                *ngIf="company && company._id"
                class="landlord-card--company"
                link
                (click)="clickedLandlordCompany.emit(company)">
                <apto-icon
                    aptoListItemIcon
                    icon="property"
                    size="5"
                    circle
                    circleColor="orange">
                </apto-icon>
                <p *ngIf="company.name" class="landlord-card--name dark-text">{{company.name}}</p>
                <p *ngIf="company.type" class="landlord-card--text landlord-card--companyType">{{company.type}}</p>
                <p *ngIf="company.billingAddress || company.shippingAddress" class="landlord-card--text landlord-card--address">{{company.billingAddress || company.shippingAddress}}</p>
            </apto-list-item>
            <apto-list-item
                *ngIf="contact && contact._id"
                class="landlord-card--contact"
                link
                (click)="clickedLandlordContact.emit(contact)">
                <apto-icon
                    aptoListItemIcon
                    icon="person"
                    size="5"
                    circle
                    circleColor="gray">
                </apto-icon>
                <p *ngIf="contact.fullName" class="landlord-card--name landlord-card--fullName dark-text">{{contact.fullName}}</p>
                <p *ngIf="contact.type" class="landlord-card--text landlord-card--contactType">{{contact.type}}</p>
                <p *ngIf="contact.title" class="landlord-card--text landlord-card--title">{{contact.title}}</p>
            </apto-list-item>
        </apto-list>
    </apto-card-content>
</apto-card>